import { BordBadge } from 'bord-design-system';
import { EQuoteItemStatusCode } from 'types/quote.types';
import { IQuoteItemDetailsForQuoteManagement } from 'types/quoteEditor.types';
import { filterPillsToShow } from '../../../../../utils/pillsFormat';
import { getCategoryName } from '../../../../../utils/namingConventionsManagement';
import { PRODUCT_CATEGORY } from '../../../../../types/category';
import BordProductImageWithBrand from 'components/NudosComponents/BordProductImageWithBrand/BordProductImageWithBrand';
import QuoteProductPill from '../QuoteProductPill/QuoteProductPill';
import './QuoteEditorToolListItem.scss';

interface IQuoteEditorToolListItem {
  item: IQuoteItemDetailsForQuoteManagement;
  status: EQuoteItemStatusCode;
  isSelected: boolean;
  handleClick: (id: number) => void;
}

/**
 * Tarjeta individual de herramienta en el sidebar del editor.
 * Muestra imagen, nombre, specs o badge "Personalizado" y estado de cotización.
 */
const QUOTED_STATUSES = [
  EQuoteItemStatusCode.QUOTED,
  EQuoteItemStatusCode.PENDING_APPROVAL,
  EQuoteItemStatusCode.APPROVED,
  EQuoteItemStatusCode.PURCHASED,
  EQuoteItemStatusCode.REJECTED,
  EQuoteItemStatusCode.EXPIRED
];

const QuoteEditorToolListItem = ({ item, status, isSelected, handleClick }: IQuoteEditorToolListItem) => {
  const isQuoted = QUOTED_STATUSES.includes(status);
  const statusLabel = isQuoted ? 'Cotizada' : 'Por cotizar';
  const classNames = `quoteEditorToolListItem${isSelected ? ' selected' : ''}`;
  const pillsToShow = filterPillsToShow(item.pills || {});

  return (
    <div className={classNames} onClick={() => handleClick(item.quoteItemId)}>
      <div className="itemLeft">
        <BordProductImageWithBrand imageUrl={item.imageUrl} brandImageUrl={item.brandImage} />
        <div className="itemInfo">
          <div className="itemName">{item.productName ?? getCategoryName(item.categoryName as PRODUCT_CATEGORY)}</div>
          {item.isGenericProduct && (
            <BordBadge className="genericBadge" label="Personalizado" variant="gradient" size="small" />
          )}
          {!item.isGenericProduct && item.pills && (
            <div className="itemSpecs">
              {pillsToShow.map(value => (
                <QuoteProductPill key={value} label={value} />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="itemStatus">
        <div className={`statusDot${isQuoted ? ' quoted' : ''}`} />
        <span className={`statusLabel${isQuoted ? ' quoted' : ''}`}>{statusLabel}</span>
      </div>
    </div>
  );
};

export default QuoteEditorToolListItem;
